module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc10-22506935e0c57d5aef9078b91e7205d8.jpg";